// @flow
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { colors } from '../../constants';

type DayOption = {
  label: string,
  value: any,
};

type Props = {
  hasErrors?: boolean,
  options: Array<DayOption>,
  daysOfWeek?: Array<any>,
  onChange: Function,
};

const selectedDaysOfWeek = (daysOfWeek, dayChanging) => {
  if (!Array.isArray(daysOfWeek)) {
    daysOfWeek = [];
  }

  if (daysOfWeek.indexOf(dayChanging) > -1) {
    return daysOfWeek.filter(day => day !== dayChanging);
  }
  return [...daysOfWeek, dayChanging];
};

const DaysOfWeekPicker = (props: Props) => {
  const { hasErrors, daysOfWeek, onChange, options } = props;

  const isDayActive = dayValue =>
    selectedDaysOfWeek(daysOfWeek, null).includes(dayValue);

  return (
    <Fragment>
      {options.map(({ label, value }) => {
        return (
          <DayIcon
            key={value}
            active={isDayActive(value)}
            data-active={isDayActive(value)}
            hasErrors={hasErrors}
            onClick={() => onChange(selectedDaysOfWeek(daysOfWeek, value))}
          >
            {label}
          </DayIcon>
        );
      })}
    </Fragment>
  );
};

DaysOfWeekPicker.defaultProps = {
  hasErrors: false,
};

export default DaysOfWeekPicker;

const DayIcon = styled.div`
  align-items: center;
  background-color: ${props =>
    props.active ? colors.mediumGreenhouseGreen : colors.lightGrey};
  border: ${props =>
    props.hasErrors ? `1px solid ${colors.darkRed}` : undefined};
  border-radius: 50%;
  box-sizing: border-box;
  color: ${props => (props.active ? colors.white : colors.darkestGrey)};
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  height: 24px;
  justify-content: center;
  margin-right: 0.5rem;
  padding: 0.5rem;
  width: 24px;
`;
